// @ts-check
import './status-legend.scss';
import { h } from 'preact';

import StatusCheckbox from './components/StatusCheckbox';
import Status from './components/Status';

const { __ } = wp.i18n;

/**
 * @param {object} props
 * @param {import('../../types').StatusForMap[]} props.statuses
 * @param {(value: import('../../types').StatusValue) => void=} props.handleChange
 * @param {string} props.mapId
 */
export default function StatusLegend({ statuses, mapId, handleChange }) {
	return (
		<div className="status-legend-container">
			{statuses.length > 0 &&
				<ul className="status-items-container">
					{statuses.map(status => (
						<li className="status-item-container" key={status.value}>
							{typeof handleChange === 'function' ?
								<StatusCheckbox {...status} id={`status-${status.value}-map-${mapId}`} handleChange={handleChange} /> :
								<Status {...status} />
							}
						</li>
					))}
				</ul>}
		</div>
	);
}
